var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHorarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "#285171"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 15.6667H31.3333V13.0001H12.6667V15.6667ZM12.6667 34.3334C11.9333 34.3334 11.3058 34.0725 10.784 33.5507C10.2622 33.029 10.0009 32.401 10 31.6667V13.0001C10 12.2667 10.2613 11.6392 10.784 11.1174C11.3067 10.5956 11.9342 10.3343 12.6667 10.3334H14V7.66675H16.6667V10.3334H27.3333V7.66675H30V10.3334H31.3333C32.0667 10.3334 32.6947 10.5947 33.2173 11.1174C33.74 11.6401 34.0009 12.2676 34 13.0001V20.5667C33.5778 20.3667 33.1444 20.2001 32.7 20.0667C32.2556 19.9334 31.8 19.8334 31.3333 19.7667V18.3334H12.6667V31.6667H21.0667C21.2222 32.1556 21.4058 32.6223 21.6173 33.0667C21.8289 33.5112 22.0787 33.9334 22.3667 34.3334H12.6667ZM30 35.6667C28.1556 35.6667 26.5836 35.0165 25.284 33.7161C23.9844 32.4156 23.3342 30.8436 23.3333 29.0001C23.3324 27.1565 23.9827 25.5845 25.284 24.2841C26.5853 22.9836 28.1573 22.3334 30 22.3334C31.8427 22.3334 33.4151 22.9836 34.7173 24.2841C36.0196 25.5845 36.6693 27.1565 36.6667 29.0001C36.664 30.8436 36.0138 32.4161 34.716 33.7174C33.4182 35.0187 31.8462 35.6685 30 35.6667ZM32.2333 32.1667L33.1667 31.2334L30.6667 28.7334V25.0001H29.3333V29.2668L32.2333 32.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHorarios);
export default __webpack_public_path__ + "static/media/ic_horarios.cd1ab0ae9b3aa0ad1c54f7447a263a75.svg";
export { ForwardRef as ReactComponent };